export default __webpack_public_path__ + "static/Kira Kutcher - Age 20 Attending College Class-14454a671c2a334fbd5f56d4dae2636a.png";